import Leads from "components/Leads/Leads";
import React, { Component } from "react";
export default class LeadContainers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "1",
      formData: {
        fromat_date_from: "",
        fromat_date_to: "",
        from_date: "",
        to_date: "",
      },
      formError: {
        id: false,
        name: false,
        mobile: false,
        created_at: false,
        filter_date: false,
        email: false,
      },
      ErrorMsg: "",
      datePickerOpen: false,
    };
  }
  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };

  handleTabChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  async componentDidMount() {
    this.props.getLeadsAction();
    this.props.getOwnerListDataAction();
    this.props.getHostListDataAction();
  }

  handleFilterApiData = async () => {
    const { value } = this.state;
    if (value === "1") {
      await this.props.getLeadsAction({
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
      });
    } else if (value === "2") {
      await this.props.getOwnerListDataAction({
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
      });
    } else if (value === "3") {
      await this.props.getHostListDataAction({
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
      });
    }
  };
  handleReset = async () =>{
    const { value } = this.state;
    if (value === "1") {
      await this.props.getLeadsAction();
    } else if (value === "2") {
      await this.props.getOwnerListDataAction();
    } else if (value === "3") {
      await this.props.getHostListDataAction();
    }
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }
  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    // this.handleFilterApiData();
    this.setState({ formData });
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }
  render() {
    const leadData = this.props.leadsDataList?.customerDetails?.reverse();
       const  ownerData=this.props.OwnerListData.reverse();
       const hostData=this.props.HostListData.reverse();
    return (
      <div>
        <Leads
          onDatePickerSub={this.onDatePickerSub}
          props={this.props}
          isLoading={this.props.isLoading}
          isError={this.state.ErrorMsg}
          onChange={this.handleChange}
          datePickerOpen={this.state.datePickerOpen}
          handleDatePickerOpen={this.handleDatePickerOpen}
          handleDatePickerClose={this.handleDatePickerClose}
          from_date={this.state.formData.from_date}
          to_date={this.state.formData.to_date}
          fromat_date_from={this.state.formData.fromat_date_from}
          fromat_date_to={this.state.formData.fromat_date_to}
          lead_data={leadData}
          owner_data={ownerData}
          host_data={hostData}
          handleTabChange={this.handleTabChange}
          // downloadAsExcel={this.downloadAsExcel}
          value={this.state.value}
          handleReset={this.handleReset}
        />
      </div>
    );
  }
}
